import styled from 'styled-components/macro';
import { FONT_FAMILY, FONTS } from 'utils/styles/fonts';
import { COLORS } from 'utils/styles/colors';
import { FLEX_CONTAINER } from 'utils/styles/flex';
import { deviceMax } from 'utils/styles/breakpoints';

export const Form = styled.form`
  ${FLEX_CONTAINER.FlexSpaceBetweenColumn};
  flex-wrap: wrap;
  gap: 30px;
  width: 100%;
  padding-bottom: 50px;

  @media only screen and ${deviceMax.laptopLMax} {
    padding-bottom: unset;
    ${FLEX_CONTAINER.FlexCenterColumn};
  }
`;

export const BackSubmitBlock = styled.div`
  ${FLEX_CONTAINER.FlexCenterRow}
  gap: 20px;
  width: 100%;
  margin-top: 80px;

  @media only screen and ${deviceMax.tablet} {
    flex-direction: column-reverse;
    padding-bottom: 100px;
  }
`;

export const EditUserInfo = styled.div`
  width: 100%;
  padding: 20px 80px 88px 80px;

  @media only screen and ${deviceMax.laptopLMax} {
    padding: 20px 80px 150px 80px;
  }

  @media only screen and ${deviceMax.mobileL} {
    padding: 10px;
  }
`;

export const FormButton = styled.button`
  width: 180px;
  height: 40px;
  background: none;
  border: 2px solid ${COLORS.mainColor};
  color: ${COLORS.mainColor};
  ${FONTS.font16}
  border-radius: 10px;
`;

export const FormButtonActive = styled.button`
  width: 180px;
  height: 40px;
  background: ${COLORS.mainColor};
  border: none;
  color: ${COLORS.white};
  ${FONTS.font16}
  border-radius: 10px;
  &:hover {
    background: ${COLORS.mainColor_op7};
  }
`;

export const StyledInput = styled.input`
  ${FONTS.font16}
  width: 100%;
  height: 36px;
  border: none;
  outline: none;
  background: none;
  border-bottom: 1px solid ${COLORS.mainColor};

  &::placeholder {
    ${FONTS.font16}
    ${FLEX_CONTAINER.FlexRow};
    color: ${COLORS.mainColor};
    ${FONT_FAMILY.FontLight}
  }

  @media only screen and ${deviceMax.mobileL} {
    &::placeholder {
      ${FONTS.font12}
    }
  }
`;

export const InputBlock = styled.div`
  position: relative;
  margin-top: 40px;
  width: 250px;
`;

export const PasswordVisibleIcon = styled.img`
  position: absolute;
  right: 0px;
  top: 12px;
  width: 26px;
  cursor: pointer;

  @media only screen and ${deviceMax.desktop} {
    width: 20px;
    right: 0px;
    cursor: pointer;
  }

  @media only screen and ${deviceMax.mobileL} {
    width: 16px;
  }
`;

export const ErrorMessage = styled.span`
  ${FONT_FAMILY.FontRegular};
  ${FONTS.font14}
  text-transform: capitalize;
  color: ${COLORS.red};
`;
